import React from 'react';

import LoadingSpinner from '@components/LoadingSpinner';

import logo from '@assets/logo.png';
import loader from '@assets/loader.gif';
import { appThemeConfiguration } from '@appConfig';

export default function HomeLoader() {
  const isAnimated = appThemeConfiguration.APP_LOADING_LOGO?.endsWith('.gif');

  return (
    <div className="w-screem flex h-screen flex-col items-center justify-center bg-header-container">
      <div className="flex w-full flex-col items-center justify-center gap-2 ">
        <img src={isAnimated ? loader : logo} className="h-16 md:h-28" />
        {!isAnimated && <LoadingSpinner size="mr-4 h-12 w-12" />}
      </div>
    </div>
  );
}
